import React, { useEffect, useRef, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { smlUrl } from "../../../../../utils/config";

const DigitalSignPopupComponent = ({
  url,
  openDialog,
  handleCloseScreen,
  handleDigitalSignatureResponsePopup,
}) => {
  // const iframeRef = useRef(null);

  // useEffect(() => {
  //   const handleMessage = (event) => {
  //     // Ensure the message comes from DocuSign
  //     console.log(event);
  //     console.log(event.origin)
  //     console.log(event.data)
  //     // if (event.origin.includes("docusign-return")) {
  //     //   console.log("Message from DocuSign:", event.data);

  //     //   // Check if signing is complete
  //     //   if (event.data?.event === "signing_complete") {
  //     //     handleCloseScreen(); // Close dialog when signing completes
  //     //   }
  //     // }
  //   };

  //   window.addEventListener("message", handleMessage);

  //   return () => {
  //     window.removeEventListener("message", handleMessage);
  //   };
  // }, [handleCloseScreen]);

  // const handleIframeLoad = () => {
  //   const iframe = iframeRef.current;
  //   console.log(iframe)
  //   console.log(iframe.contentWindow.location.href)
  //   if (iframe) {
  //     const currentUrl = iframe.contentWindow.location.href;
  //     console.log("Iframe URL changed to:", currentUrl);

  //     // Close the dialog if the URL no longer matches the initial one
  //     if (currentUrl.includes("docusign-return")) {
  //       if (currentUrl.includes("signing_complete")) {
  //         handleDigitalSignatureResponsePopup('success');
  //         handleCloseScreen();
  //       }
  //       if (currentUrl.includes("sign-failed") || currentUrl.includes("ttl_expired")) {
  //         handleDigitalSignatureResponsePopup('failed');
  //         handleCloseScreen();
  //       }
        
  //     }
  //   }
  // };

  const [popup, setPopup] = useState(null);

  useEffect(() => {
    // Only open a new popup if one isn't already open
    if (!popup || popup.closed) {
      //console.log('open pop-up')
      const width = 1200;
      const height = 1200;
      const left = (window.innerWidth - width) / 2;
      const top = (window.innerHeight - height) / 2;
      const popupParams = `width=${width},height=${height},top=${top},left=${left}`;
      const newPopup = window.open(url, '_blank', popupParams);
      //console.log(newPopup)
      if (!newPopup) {
        handleDigitalSignatureResponsePopup('failed');
        handleCloseScreen();
      } else {
      setPopup(newPopup);
      }
    } else {
      // Bring the existing popup to the foreground
      popup.focus();
    }

    const messageHandler = (event) => {
      //console.log(event)
      //console.log(event.origin)
      //console.log(event.data)
      if (event.origin === smlUrl && event.data === 'sign-success') {
        if (popup) {
          popup.close();
          setPopup(null);
        }
        handleDigitalSignatureResponsePopup('success');
        handleCloseScreen();
      }
      if (event.origin === smlUrl && event.data === 'sign-failed') {
        if (popup) {
          popup.close();
          setPopup(null);
        }
        handleDigitalSignatureResponsePopup('failed');
        handleCloseScreen();
      }
      if (event.origin === smlUrl && event.data === 'ttl_expired') {
        if (popup) {
          popup.close();
          setPopup(null);
        }
        handleDigitalSignatureResponsePopup('failed');
        handleCloseScreen();
      }
      if (event.origin === smlUrl && event.data === 'decline') {
        if (popup) {
          popup.close();
          setPopup(null);
        }
        handleDigitalSignatureResponsePopup('success','Rejected');
        handleCloseScreen();
      }
    };

    window.addEventListener('message', messageHandler);
    return () => {
      //console.log('event removed')
      window.removeEventListener('message', messageHandler);
      if (popup) {
        popup.close();
      }
    };
  }, [url]); // Dependency on the URL

  return (
    <Dialog open={openDialog} fullWidth maxWidth="lg">
      {/* <iframe
        ref={iframeRef}
        src={url}
        title="DocuSign Embedded Signing"
        width="100%"
        height="900px"
        allowFullScreen
        // onLoad={handleIframeLoad}
      /> */}
    </Dialog>
  );
};

export default DigitalSignPopupComponent;
